import styled from 'styled-components';
import { FlexAlignCenterJustifyEnd } from 'components/primitives/flex';
import React from 'react';

interface Props {
  isActive: boolean;
  offLabel?: string;
  onLabel?: string;
  onChange?: () => void;
  primaryColor?: string;
  secondaryColor?: string;
  invertColor?: boolean;
  round?: boolean;
  disabled?: boolean;
  icon?: React.ReactElement;
}

const ToggleSwitch = (props: Props) => {
  const {
    isActive,
    onChange,
    offLabel = 'Show map',
    onLabel = 'Hide map',
    disabled = false,
    primaryColor = '#0751c2',
    secondaryColor = 'white',
    invertColor = false,
    round = false,
    icon = null,
  } = props;
  return (
    <ToggleSwitchWrapper aria-checked={isActive} tabIndex={0} onClick={disabled ? () => {} : onChange}>
      {onLabel || offLabel ? <ToggleLabel>{isActive ? onLabel : offLabel}</ToggleLabel> : null}
      <ToggleSwitchControl
        data-testid="switch"
        backgroundColor={invertColor ? primaryColor : secondaryColor}
        className={`${round ? 'roundSwitch' : ''} ${isActive === false ? 'disabled' : ''} ${
          disabled ? 'toggleBoxDisabled' : ''
        }`}
      >
        <ToggleSwitchBox
          backgroundColor={invertColor ? secondaryColor : primaryColor}
          className={`${round ? 'roundSwitchInside' : ''} ${isActive === false ? 'disabled' : ''}`}
        >
          {icon && icon}
        </ToggleSwitchBox>
      </ToggleSwitchControl>
    </ToggleSwitchWrapper>
  );
};

export default ToggleSwitch;

const ToggleSwitchWrapper = styled(FlexAlignCenterJustifyEnd).attrs({ role: 'switch' })`
  &:focus {
    outline: none;
  }
  cursor: pointer;
`;

const ToggleLabel = styled.span`
  margin-right: 1em;
  font-size: 0.875em;
  line-height: 1.714285;
  margin-bottom: 0;
`;

const ToggleSwitchControl = styled.div<{ backgroundColor: string }>`
  width: 59px;
  height: 36px;
  padding: 5px;
  padding-right: 6px;
  padding-left: 6px;
  background: ${(props) => (props.backgroundColor ? props.backgroundColor : '#ffffff')};
  box-sizing: border-box;
  border: 1px solid #0751c2;
  border-radius: 5px;
  transition: color 280ms ease-in-out;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;

  &.disabled {
    background: #c0c0c0 !important;
    border: 1px solid #c0c0c0;
  }

  &.roundSwitch {
    border-radius: 16px !important;
    width: 48px !important;
    height: 32px !important;
    padding: 3px !important;
  }

  &.toggleBoxDisabled {
    cursor: auto;
    opacity: 0.4;
  }
`;

const ToggleSwitchBox = styled.div<{ backgroundColor: string }>`
  margin-left: calc(100% - 24px);
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: ${(props) => (props.backgroundColor ? props.backgroundColor : '#0751c2')};
  transition: all 280ms ease-in-out;
  display: flex;

  &.disabled {
    margin-left: 0;
    background: white !important;
  }

  &.roundSwitchInside {
    border-radius: 100px !important;
    width: 24px !important;
    height: 24px !important;
  }
`;
